import React ,{Component} from 'react';
import JobsService from '../../../services/JobsService';
import {Link} from 'react-router-dom';
import Jobs from './jobs.json';

export default class Show extends Component{
    constructor(props){
        super(props);
        this.state = {
            // job : Jobs[this.props.match.params.id-1],
            job : {
                id : "",
                name : "",
                qualifications : [],
                responsibilities : [],
                form_url : ""
            },
            isLoading : true
        };
        this.JobsService = new JobsService('indonesian');
    };
    // async componentDidMount(){
    //     let id = this.props.match.params.id;
    //     let response = await JobsService.show(id);
    //     this.setState({
    //         job : response.data,
    //         isLoading : false
    //     });
    // }

    async componentDidMount(){
        const id = this.props.match.params.id;
        const jobs = await this.JobsService.jobs;
        const job = jobs[id-1]._rawData;
        this.setState({
            job : {
                id : job[0],
                name : job[1],
                qualifications : job[2].split(';'),
                responsibilities : job[3].split(';'),
                form_url  : job[4]
            },
            isLoading : false
        })
        
    }
    render(){
        if(this.state.isLoading)
            return(
                <div className="w-100">
                    <div className="text-center">
                        <div class="spinner-grow" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
            );
        return(
            <div class="container pt-5">
                <div class="row">
                    <div class="col-sm-2">
                    </div>
                    <div class="col-sm-8">
                        <div className="w-100">
                            <h1 className="font-weight-bold">{this.state.job.name}</h1>
                            <h4 className="pt-5 font-weight-bold">Kewajiban</h4>
                            <ul>
                                {this.state.job.responsibilities.map(responsibility => {
                                    return(
                                        <li>{responsibility}</li>
                                    );
                                })}
                            </ul>
                            {/* <pre className="">{this.state.job.responsibilities}</pre> */}
                            <h4 className="pt-5 font-weight-bold">Kualifikasi</h4>
                            <ul>
                                {this.state.job.qualifications.map(qualification => {
                                    return(
                                        <li>{qualification}</li>
                                    );
                                })}
                            </ul>
                            {/* <pre className="">{this.state.job.qualifications}</pre> */}
                            <div className="w-100 py-4">
                                <a href={this.state.job.form_url} target="_blank" rel="noopener noreferrer">
                                    <button className="btn btn-lg btn-sks">Apply</button>
                                </a>
                                <Link to="/careers" className="ml-3">
                                    <button className="btn btn-lg btn-sks">Back</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                    </div>
                </div>
            </div>
        );
    }
}